import { Box } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { useEffect, useState } from "react";
import { useInventoriesQuery } from "../../services/inventoryApi";
import CsvDownloader from "../Common/CsvDownloader/CsvDownloader";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import "./Inventory.css";
import { useSelector } from "react-redux";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import ExportNav from "../Common/Nav/ExportNav";
import { InventoryRoutes } from "../../data";

const Inventory = () => {
  // let i = 1;
  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const lang = useSelector((state) => state.languageReducer);
  const auth = signInUser();
  const aamarId = auth?.aamarId;
  const storeSettings = auth?.storeSettings;

  const getInitialWarehouse = () => {
    if (auth?.type === "admin") return "allWh";
    if (auth?.warehouse) {
      if (typeof auth.warehouse === "object") {
        return auth.warehouse._id || auth.warehouse.id || "allWh";
      }
      return auth.warehouse;
    }
    return "allWh";
  };

  const [warehouse, setWarehouse] = useState(getInitialWarehouse);
  const [loader, setLoader] = useState(true);

  const handleLoaderClose = () => setLoader(false);

  const { data, error, isLoading, isFetching, refetch } = useInventoriesQuery({
    aamarId,
    warehouse,
    // q,
  });

  useEffect(() => {
    if (auth) {
      const wh = getInitialWarehouse();
      setWarehouse(wh);
    }
  }, [auth?.warehouse, auth?.type]);

  console.log("Inventory", data);
  // console.log("warehouse", warehouse);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);

  useEffect(() => {
    console.log(error);
  }, [error]);

  // Columns for MaterialReactTable
  const columns = [
    { accessorKey: "article_code", header: "Article Code", size: 120 },
    { accessorKey: "name", header: "Name", size: 160 },
    { accessorKey: "unit", header: "Unit", size: 140 },
    {
      accessorKey: "openingQty",
      header: "Opening Stock",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "totalQty",
      header: "Purchase Qty (GRN)",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "soldReturnQty",
      header: "Sales Return Qty",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "adjustQty",
      header: "Receive Adjustment",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "availableStock",
      header: "Available Stock",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "soldQty",
      header: "Sale Qty",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "rtvQty",
      header: "RTV Qty",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "tpnQty",
      header: "TPN Qty",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "damageQty",
      header: "Damage Qty",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "otherAdjustQty",
      header: "Issue Adjustment",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "closingStock",
      header: "Closing Stock",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "tp",
      header: "TP",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "mrp",
      header: "MRP",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
    {
      accessorKey: "stockValue",
      header: "Stock Value",
      Cell: ({ cell }) => parseFloat(cell.getValue() || 0).toFixed(2),
    },
  ];
  // console.log("storeSettings", storeSettings);
  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [
      `${storeSettings?.address?.street || "No-Street"} ,${
        storeSettings?.address?.city || "No-City"
      }, ${storeSettings?.address?.state || "No-State"}, ${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    ["Inventory Details Report"],
  ];

  useEffect(() => {
    refetch();
  }, [warehouse]);

  console.log("warehouse", warehouse);
  const handleOnchangeWareHouse = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
    console.log("handle data:", e);
    refetch();
  };

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Products Inventory"></Header>

            <div className="row mt-3 mb-2 align-items-center">
              <div className="col-md-5"></div>
              <div className="col-md-7">
                <span className="float-end">
                  <ExportNav
                    data={data || []}
                    title="Products Inventory"
                    Routes={InventoryRoutes}
                  />
                </span>
              </div>
            </div>

            {/* Table */}
            <div className="text-center mt-2">
              <MaterialReactTable
                columns={columns}
                data={data || []}
                // enableRowSelection
                enableRowVirtualization // Enables row virtualization
                positionToolbarAlertBanner="bottom"
                initialState={{
                  density: "compact",
                  pagination: { pageIndex: 0, pageSize: 18 },
                }}
                renderTopToolbarCustomActions={() => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                      // Responsive styling for small devices
                      "@media (max-width: 600px)": {
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "0.5rem",
                        p: "0.3rem",
                      },
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-start gap-2">
                    <CsvDownloader
                      preheader={preHeader}
                      buttonName={
                        <span className="download-text">
                          {lang?.downloadInventoryData}
                        </span>
                      }
                      data={data || []}
                      fileName={`Export Inventory - [${today?.toDateString()}].csv`}
                      sx={{
                        padding: { xs: "0.4rem 0.8rem", sm: "0.5rem 1rem" },
                      }}
                    />

                    <div>
                      {auth?.type === "admin" && (
                        <div
                          className="mt-2 mt-md-0  mb-md-0 "
                          style={{
                            position: "relative",
                            zIndex: 100,
                            width:
                              window.innerWidth >= 1024
                                ? 280
                                : window.innerWidth >= 768
                                ? 280
                                : "100%", // Adjust width based on screen size
                          }}
                        >
                          <WareHouseDW
                            id="warehouse"
                            name="warehouse"
                            className="col-md-4 ms-2 z-999 position-absolute"
                            handleOnChange={handleOnchangeWareHouse}
                            MenuProps={{
                              container: document.body,
                            }}
                          />
                        </div>
                      )}
                    </div>
                    </div>
                  </Box>
                )}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <InventoryViewModal
        onShow={onShow}
        handleClose={handleClose}
        code={code}
      /> */}
      {/* <ExportInventory
        pageCountQuery={pageCountQuery?.data}
        onShow={onExportShow}
        handleClose={handleExportClose}
      /> */}
    </div>
  );
};

export default Inventory;
